export default __webpack_public_path__ + "static/cameras-mobile-410073788f94473c865588e9e2de3979.png";